import { FC } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Text from '@components/common/text';
import Icon from '@components/common/assets';
import CustomImage from '@components/common/image';
import { ContentsListItemVO } from '@domain/vo/common/ContentsListItemVO';
import NoAffiliateAuthModal from '@components/common/modals/affiliateModal/noAffiliateAuthModal';
import NoMatchingUserModal from '@components/common/modals/affiliateModal/noMatcingUserModal';
import { usePassReviewContents } from '@repository/post/usePost';
import LoginModal from '@components/loginModal';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { RouteUrl, V2Route } from '@utils/routeUtil';
import useContentAccessControl from '@utils/hooks/useContentAccessControl';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  data: ContentsListItemVO;
  handleClick: (contentData: ContentsListItemVO) => boolean;
}
const Item: FC<ItemProps> = ({ data, handleClick }) => {
  const router = useRouter();

  const handleOnClick = () => {
    const canViewContent = handleClick ? handleClick(data) : true;
    if (canViewContent) {
      router.push(data.routeUrl);
    }
  };

  return (
    <button className={cx('item')} type="button" onClick={handleOnClick}>
      <div className={cx('row')}>
        <div className={cx('imgWrap')}>
          <div className={cx('img')}>
            {data.thumbnailUrl ? (
              <CustomImage src={data.thumbnailUrl} alt={data.title} width={282} height={180} pointer />
            ) : (
              <Icon name="logo" width={160} height={36} fill={Colors.C_COOL_GRAY_50} />
            )}
          </div>
        </div>
        <Text fontStyle={FontStyle.B1_B} styles={{ marginTop: '12px' }}>
          <span className={cx('title')}>{data.title}</span>
        </Text>
      </div>
      <Text fontStyle={FontStyle.B3_M} color={Colors.C_COOL_GRAY_60}>
        {data.tag}
      </Text>
    </button>
  );
};

const Tip = () => {
  const { data } = usePassReviewContents({ page: 0, size: 3 });
  const {
    handleCardClick,
    loginModalVisible,
    noAffiliateAuthModalVisible,
    redirectUrl,
    setLoginModalVisible,
    setNoAffiliateAuthModalVisible,
    noAffiliateAuthModalTitle,
    noMatchingUserModalVisible,
    setNoMatchingUserModalVisible,
  } = useContentAccessControl();

  const itemEl = data?.posts.map((item) => {
    const contentData = new ContentsListItemVO({
      ...item,
      name: item.categoryName,
      tag: item.label,
      routeUrl: V2Route.getInfoDetailPage(item.sn),
    });

    return <Item key={item.sn} data={contentData} handleClick={handleCardClick} />;
  });

  return (
    <>
      <div className={cx('wrapper')}>
        <Text fontStyle={FontStyle.H4_B}>JOBDA로 합격한 선배들의 합격 꿀팁 대공개</Text>
        <div className={cx('itemlist')}>
          {itemEl}
          <Link className={cx('matchcard')} href={RouteUrl.MATCH_INTRODUCE}>
            <Text fontStyle={FontStyle.H4_B}>
              다음 합격의
              <br />
              주인공은 당신입니다!
            </Text>
            <Text fontStyle={FontStyle.B3_M} styles={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
              JOBDA로 취업하는 방법 확인
              <Icon name="arrowRightLight" width={24} height={24} />
            </Text>

            <div className={cx('img')}>
              <img src={'/img/v2/components/passboard/matching_green.png'} alt="matchImg" width={100} height={100} />
            </div>
          </Link>
        </div>
      </div>
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
      <NoAffiliateAuthModal
        title={noAffiliateAuthModalTitle}
        visible={noAffiliateAuthModalVisible}
        onClose={() => setNoAffiliateAuthModalVisible(false)}
      />
      <NoMatchingUserModal visible={noMatchingUserModalVisible} onClose={() => setNoMatchingUserModalVisible(false)} />
    </>
  );
};

export default Tip;
